import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { RequestNetworkError } from '../core/RequestError';

function timeout(time) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new RequestNetworkError("\u7F51\u7EDC\u8BF7\u6C42\u8D85\u65F6(".concat(time / 1000, "s)\uFF0C\u8BF7\u91CD\u8BD5"), -5));
    }, time);
  });
}

export default function () {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.race([next(), timeout(time)]);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}